.button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: var(--ds-space-sm);
  border: var(--ds-stroke-default) solid transparent;
  white-space: nowrap;
  cursor: pointer;
  transition:
    box-shadow 0.2s ease,
    background-color 0.2s ease;
  box-sizing: border-box;
}

.button > svg {
  flex-shrink: 0;
}

.label {
  display: inline-block;
}

/* Sizes — tipografía (compound token), alto, padding horizontal y radio */
.sizeS {
  composes: text-label-button-s from global;
  height: 30px;
  padding-inline: var(--ds-space-md);
  border-radius: var(--ds-radius-btn-sm);
}

.sizeM {
  composes: text-label-button-m from global;
  height: 40px;
  padding-inline: var(--ds-space-lg);
  border-radius: var(--ds-radius-btn);
}

/* Variants */
.button[data-variant="primary"] {
  background: var(--ds-color-text-hi);
  color: var(--ds-color-text-on-primary);
}

.button[data-variant="secondary"] {
  background: transparent;
  color: var(--ds-color-text-hi);
  border-color: var(--ds-color-line-strong);
}

.button[data-variant="ghost"] {
  background: transparent;
  color: var(--ds-color-text-hi);
}

.button[data-variant="destructive"] {
  background: transparent;
  color: var(--ds-color-status-bad);
  border-color: var(--ds-color-status-bad);
}

/* Variants — inverse (destructive no expone inverse) */
.button[data-inverse="true"][data-variant="primary"] {
  background: var(--ds-color-bg-page);
  color: var(--ds-color-text-hi);
}

.button[data-inverse="true"][data-variant="secondary"] {
  color: var(--ds-color-text-inverse);
  border-color: var(--ds-color-text-inverse);
}

.button[data-inverse="true"][data-variant="ghost"] {
  color: var(--ds-color-text-inverse);
}

/* Hover — elevation/lg + cambio de fondo por variante (las sombras del
   sistema son negras: sobre fondo oscuro y en ghost no se perciben) */
.button:hover:not(:disabled) {
  box-shadow: var(--ds-elevation-lg);
}

.button[data-variant="secondary"]:hover:not(:disabled),
.button[data-variant="ghost"]:hover:not(:disabled) {
  background: var(--ds-color-bg-elev-2);
}

.button[data-inverse="true"][data-variant="primary"]:hover:not(:disabled) {
  background: var(--ds-color-bg-elev-2);
}

.button[data-inverse="true"][data-variant="secondary"]:hover:not(:disabled),
.button[data-inverse="true"][data-variant="ghost"]:hover:not(:disabled) {
  background: var(--ds-color-bg-hover-inverse);
}

.button:focus-visible {
  outline: var(--ds-stroke-focus) solid var(--ds-color-accent-primary);
  outline-offset: 2px;
}

.button:disabled {
  cursor: not-allowed;
  background: transparent;
  color: var(--ds-color-text-disabled);
  border-color: transparent;
}

.button[data-variant="primary"]:disabled {
  background: var(--ds-color-bg-elev-2);
}

.button[data-variant="secondary"]:disabled,
.button[data-variant="destructive"]:disabled {
  border-color: var(--ds-color-line-default);
}

.button[data-inverse="true"]:disabled {
  color: var(--ds-color-text-mute);
}

.button[data-inverse="true"][data-variant="primary"]:disabled {
  background: var(--ds-color-text-mute);
  color: var(--ds-color-text-disabled);
}

.button[data-inverse="true"][data-variant="secondary"]:disabled {
  border-color: var(--ds-color-text-mute);
}
